import gql from 'graphql-tag';

import client from '../graphqlAPI';

// Deletes a radio tag or category.
const POST_DELETE_RADIO_TAG = gql`
  mutation postDeleteRadioTag($id: Int!) {
    postDeleteRadioTag(id: $id) {
      isAuth
      ok
      errors { field message }
    }
  }
`;

const postDeleteRadioTag = async ({ id }) => {
  try {
    const result = await client
      .mutate({
        mutation: POST_DELETE_RADIO_TAG,
        variables: { id },
        fetchPolicy: 'no-cache',
      })
      .then(queryResult => queryResult)
      .catch((queryError) => {
        console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: Apollo Client Query Error: ${queryError}`);
        return null;
      });

    const {
      data: { postDeleteRadioTag: postDeleteRadioTagData },
    } = result;

    if (postDeleteRadioTagData) {
      return postDeleteRadioTagData;
    }
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: GraphQL Query Error: postDeleteRadioTag = null`);
    return null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ Client: postDeleteRadioTag Error: ${error}`);
    return null;
  }
};

export default postDeleteRadioTag;
